import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Star } from 'lucide-react';
import './StarRating.css';

const StarRating = ({ value, onChange, disabled }) => {
  const { t } = useTranslation(['qms']);
  const [hover, setHover] = useState(null);
  const display = hover ?? value;

  const setRating = (n) => {
    if (disabled) return;
    onChange?.(n);
  };

  return (
    <div
      className="star-rating"
      role="radiogroup"
      aria-label={t('qms:ratingLabel')}
      onMouseLeave={() => !disabled && setHover(null)}
    >
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = display != null && n <= display;
        return (
          <button
            key={n}
            type="button"
            role="radio"
            aria-checked={value === n}
            className={`star-rating-btn ${filled ? 'filled' : ''}`}
            disabled={disabled}
            onMouseEnter={() => !disabled && setHover(n)}
            onFocus={() => !disabled && setHover(n)}
            onBlur={() => setHover(null)}
            onClick={() => setRating(n)}
            aria-label={`${n}`}
          >
            <Star size={28} strokeWidth={filled ? 0 : 1.5} fill={filled ? 'currentColor' : 'none'} />
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
